import global from './global/en.json';
import zones from './zones/en.json';

export default {
  global,
  zones
};
